var _path, _path2, _path3, _path4, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGiftBg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 389,
    height: 101,
    viewBox: "0 0 389 101",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M441.824 156H81.1234C77.9346 156 76.9479 151.683 79.82 150.298L380.36 5.31523C380.79 5.10806 381.262 5.00624 381.739 5.0182L967.567 19.7198C968.946 19.7544 970.124 20.7249 970.421 22.0719L999.195 152.353C999.608 154.226 998.183 156 996.265 156H441.824Z",
    stroke: "#00FF94",
    strokeWidth: 1.62222
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M396.824 157H36.1234C32.9346 157 31.9479 152.683 34.82 151.298L335.36 6.31523C335.79 6.10806 336.262 6.00624 336.739 6.0182L922.567 20.7198C923.946 20.7544 925.124 21.7249 925.421 23.0719L954.195 153.353C954.608 155.226 953.183 157 951.265 157H396.824Z",
    stroke: "#00FF94",
    strokeWidth: 1.62222
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M364.824 153H4.12343C0.93464 153 -0.0520992 148.683 2.81997 147.298L303.36 2.31523C303.79 2.10806 304.262 2.00624 304.739 2.0182L890.567 16.7198C891.946 16.7544 893.124 17.7249 893.421 19.0719L922.195 149.353C922.608 151.226 921.183 153 919.265 153H364.824Z",
    stroke: "#00FF94",
    strokeWidth: 1.62222
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M477.5 117.5H198.669C195.477 117.5 194.493 113.178 197.369 111.796L429.348 0.313167C429.777 0.107336 430.248 0.00619303 430.723 0.0180692L887.654 11.4414C889.032 11.4758 890.21 12.4451 890.508 13.7911L912.691 113.851C913.106 115.724 911.681 117.5 909.762 117.5H477.5Z",
    fill: "#203376"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_371_39)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M311.013 83.7705L265 71.438L268.402 77.3066L314.437 89.8608L311.013 83.7705Z",
    fill: "#00CC76",
    stroke: "#03115C",
    strokeWidth: 0.677838,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.493 37.7578L311.014 83.7707L314.438 89.861L330.001 42.6487L326.493 37.7578Z",
    fill: "#00FF94",
    stroke: "#03115C",
    strokeWidth: 0.677838,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265 71.4381L280.479 25L326.492 37.7577L311.013 83.7706L265 71.4381Z",
    fill: "white",
    stroke: "#03115C",
    strokeWidth: 0.677838,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.706 76.6085L299.724 30.3208L306.629 32.2648L291.594 78.4831L284.706 76.6085Z",
    fill: "#00FF94",
    stroke: "#03115C",
    strokeWidth: 0.677838,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.472 82.4236L284.706 76.6084L291.594 78.483L295.013 84.5597L287.472 82.4236Z",
    stroke: "#03115C",
    strokeWidth: 0.677838,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.255 68.2861C295.708 66.9261 295.444 58.5356 295.255 54.5104L297.565 53.0718C300.966 53.2897 302.666 68.8964 301.184 68.2861C299.998 67.7979 296.911 68.0827 295.255 68.2861Z",
    fill: "#FFF275",
    stroke: "#03115C",
    strokeWidth: 0.677838,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.904 65.4676C289.043 65.1553 293.654 57.7889 295.255 56.061L292.795 53.7754C287.414 56.8142 283.089 61.8862 282.717 63.1375C284.43 65.0889 286.764 65.78 287.904 65.4676Z",
    fill: "#FFF275",
    stroke: "#03115C",
    strokeWidth: 0.677838,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.265 54.2572C317.803 50.0772 306.647 50.5433 301.232 51.5356L297.557 53.4245L299.076 56.8877C313.129 72.9025 310.906 61.4373 315.265 54.2572Z",
    fill: "#FFF275",
    stroke: "#03115C",
    strokeWidth: 0.677838,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.019 56.3896C304.798 57.6261 312.911 61.3372 310.643 64.3035C308.375 67.2698 301.206 59.8026 299.019 56.3896Z",
    fill: "#8A8A8A",
    stroke: "#03115C",
    strokeWidth: 0.677838,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.447 42.1407C281.947 42.1765 290.6 47.5034 294.116 49.8271C297.222 50.4826 294.34 54.1353 293.781 54.4525C289.938 56.6321 277.358 57.4466 277.067 55.1228C276.039 44.6879 280.821 42.0959 281.447 42.1407Z",
    fill: "#FFF275",
    stroke: "#03115C",
    strokeWidth: 0.677838,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.447 55.3247C288.002 56.4328 275.894 57.9681 277.076 54.0518C277.614 49.7782 287.862 53.454 291.447 55.3247Z",
    fill: "#8A8A8A",
    stroke: "#03115C",
    strokeWidth: 0.677838,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.173 53.4727L291.872 50.9476C292.162 49.897 292.962 49.0587 294.051 49.1089C296.762 49.234 300.905 50.5265 300.836 51.3233C300.78 51.968 299.847 54.1858 299.083 55.9671C298.752 56.7384 298.153 57.3891 297.351 57.6338C293.707 58.7445 291.748 56.5773 291.153 54.8444C291.001 54.4015 291.048 53.924 291.173 53.4727Z",
    fill: "#FFF275",
    stroke: "#03115C",
    strokeWidth: 0.677838,
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_371_39",
    x: 256.661,
    y: 20.6611,
    width: 81.6787,
    height: 81.5386,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0129861 0 0 0 0 0.0373214 0 0 0 0 0.183333 0 0 0 0.44 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_371_39"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_371_39",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGiftBg);
export default __webpack_public_path__ + "static/media/giftBg.4c3990aabbed9ad774f232e2994de183.svg";
export { ForwardRef as ReactComponent };